import { MutationTree } from 'vuex'

import itemGroupsMutations from './itemGroups/mutations'
import itemsMutations from './items/mutations'
import optionGroupsMutations from './optionGroups/mutations'
import optionsMutations from './options/mutations'
import portionsMutations from './portions/mutations'
import { MenuState } from './state'

const mutations: MutationTree<MenuState> = {
  ...itemGroupsMutations,
  ...itemsMutations,
  ...optionGroupsMutations,
  ...optionsMutations,
  ...portionsMutations
}

export default mutations
